import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listVndlyPositionIssues } from 'api/admin/vndly/listVndlyPositionIssues'
import { vndlyKeys } from './keys'

export function useVndlyPositionIssuesQuery(
  request: Parameters<typeof listVndlyPositionIssues>[0]
) {
  return useQuery({
    queryKey: vndlyKeys.positionIssuesList(request),
    queryFn: () => listVndlyPositionIssues(request),
    placeholderData: keepPreviousData,
  })
}
